<script lang="ts">
    import { onMount } from 'svelte'

    import { PdfExporter } from '../../PdfExporter'

    import type { Questionnaire } from '../../types/Questionnaire'
    import type { State } from '../../types/State'
    import { ResultSender } from '../ResultSender'
    import Field from './FieldResult.svelte'

    export let state: State

    export let simpleLanguage = false

    function exportPdf() {
        new PdfExporter(questionnaire, state).exportAsPdf()
    }

    onMount(() => {
        location.href = '#ergebnisse'
        window.scrollTo(0, 0)
        new ResultSender(questionnaire, state).sendResults()
    })

    export let questionnaire: Questionnaire
</script>

<div>
    <div class="result-title">
        <div>
            <h2>Auswertung<br />Die Ergebnisse im Einzelnen</h2>
        </div>
        <div>
            <button class="elementor-button" on:click={exportPdf}>
                Ihr Selbstcheck Download
            </button>
        </div>
    </div>
    <div class="legend">
        <div style="--color:var(--color-yes)">Ja</div>
        <div style="--color:var(--color-mostly-yes)">Eher Ja</div>
        <div style="--color:var(--color-mostly-no)">Eher Nein</div>
        <div style="--color:var(--color-no)">Nein</div>
        <div style="--color:var(--color-not-relevant)">
            {#if simpleLanguage}
                Weiß ich nicht
            {:else}
                Nicht relevant
            {/if}
        </div>
    </div>
    {#each questionnaire.fields as field, index}
        <Field {field} path={[index]} {state} />
    {/each}
    <div class="toolbox-section">
        <p>
            Wenn Sie weitere Tools benötigen, schauen Sie in unsere
            <span>EwiKo Tool-Datenbank</span>.
        </p>
        <a href="/produkte/tool-datenbank/" class="elementor-button">Zur EwiKo Tool-Datenbank</a>
    </div>
</div>

<style lang="scss">
    .result-title {
        margin-top: 3.67rem;

        div:first-child {
            max-width: 62.5rem;

            h2 {
                margin: 0 0 1rem;
                font-size: 2rem;
                line-height: 1.39em;
                color: var(--color-primary);
                font-weight: 600;
            }
        }
    }

    .legend {
        display: flex;
        flex-direction: row;
        gap: 1rem;
        margin: 3rem 0;
        flex-wrap: wrap;

        @media (min-width: 790px) {
            justify-content: flex-end;
        }

        div {
            &:before {
                content: '';
                display: inline-block;
                width: 1rem;
                height: 1rem;
                border-radius: 50%;
                margin-right: 0.5rem;
                background-color: var(--color);
                vertical-align: text-top;
            }
        }
    }

    .toolbox-section {
        margin-top: 5rem;
        margin-bottom: 10rem;

        p {
            font-size: 1.5rem;
            font-weight: 600;
        }

        a {
            text-decoration: none;
        }
    }
</style>
